// path: src/auth/providers.js
// Auth providers behind a single signed-in gate (Friends requires any of these).

import {
    signInWithApple,
    signInWithFacebook,
    signInWithGoogle,
} from "../firebaseUtils";
import { isFacebookAuthConfigured } from "../utils/authConfig";
import { isAndroidApp, isNativeApp } from "../utils/nativePlatform";

export const AUTH_PROVIDER_IDS = {
    GOOGLE: "google",
    APPLE: "apple",
    FACEBOOK: "facebook",
};

const isAppleAvailableHere = () => {
    // Native Apple Sign-In is iOS-only; web/Safari uses Firebase Apple OAuth.
    if (isNativeApp() && isAndroidApp()) {
        return false;
    }
    return true;
};

const isGoogleAvailableHere = () => {
    // Capacitor WKWebView cannot complete Firebase Google redirect OAuth.
    if (isNativeApp()) {
        return false;
    }
    return true;
};

/**
 * Registry of login sources. Friends is gated on `isAuthenticated`,
 * not a specific provider.
 */
export const AUTH_PROVIDERS = [
    {
        id: AUTH_PROVIDER_IDS.APPLE,
        label: "Sign In With Apple",
        loadingLabel: "Signing in...",
        enabled: isAppleAvailableHere(),
        buttonClassName: "homePrimaryButton homeAuthButton--apple",
        signIn: signInWithApple,
    },
    {
        id: AUTH_PROVIDER_IDS.GOOGLE,
        label: "Sign In With Google",
        loadingLabel: "Signing in...",
        enabled: isGoogleAvailableHere(),
        buttonClassName: "homePrimaryButton",
        signIn: signInWithGoogle,
    },
    {
        id: AUTH_PROVIDER_IDS.FACEBOOK,
        label: "Sign In With Facebook",
        loadingLabel: "Signing in...",
        enabled: isFacebookAuthConfigured(),
        buttonClassName: "homePrimaryButton homeAuthButton--facebook",
        signIn: signInWithFacebook,
    },
];

export function getEnabledAuthProviders() {
    return AUTH_PROVIDERS.filter((provider) => provider.enabled);
}

export function isSignedInUser(user, isAuthenticated = false) {
    return Boolean(isAuthenticated && user && user.uid);
}
